export const slider = () => {
	const elem = {};
	const init = options => {
		options = options || {};
		const sliderTrack = document.querySelector(options.track);
		if (!sliderTrack) {
			return;
		}
		const sliderThumb = sliderTrack.querySelector(options.thump);
		if (!sliderThumb) {
			return;
		}
		const result = document.querySelector(options.result);
		if (!result) {
			return;
		}

		const sliderClientCoords = sliderTrack.getBoundingClientRect();
		const sliderCoords = {};

		sliderCoords.top = sliderClientCoords.top + pageYOffset;
		sliderCoords.left = sliderClientCoords.left + pageXOffset;

		sliderThumb.onmousedown = e => {
			sliderThumb.ondragstart = () => {
				return false;
			};

			const itemClientCoords = sliderThumb.getBoundingClientRect();
			const itemCoords = {};

			itemCoords.top = itemClientCoords.top + pageYOffset;
			itemCoords.left = itemClientCoords.left + pageXOffset;

			const right = sliderTrack.offsetWidth - sliderThumb.offsetWidth;
			const shiftX = e.pageX - itemCoords.left;

			document.onmousemove = evt => {
				let newLeft = evt.pageX - sliderCoords.left - shiftX;
				if (newLeft < 0) {
					newLeft = 0;
				}
				if (newLeft > right) {
					newLeft = right;
				}
				sliderThumb.style.left = newLeft + 'px';
				result.value = Math.round((newLeft / right) * 100) + '%';
				return false;
			};

			document.onmouseup = () => {
				document.onmousemove = document.onmouseup = null;
			};
		};
	};
	elem.init = init;
	return elem;
};



// WEBPACK FOOTER //
// ./app/scripts/slider.js